/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {format} from 'date-fns';
import {ContentHeader, Loader} from '@components';
import {Button} from 'react-bootstrap';
import {Tooltip} from 'react-tooltip';
import {Link, useNavigate} from 'react-router-dom';
import {logoutUser} from '@app/store/reducers/auth';
import {getAllUserNames} from '@app/services/auth';
import {
  getAllProjects,
  getAllProjectsAllowedForDevelopers
} from '../../services/project';
import handleStatus from '../../utils/ajax';
import {getUserPermission} from '../../utils/helpers';
import Pagination from '../../components/pagination';

const Status = ({status}: {status: any}) => {
  if (status === 'active') {
    return <span className="badge badge-success">Active</span>;
  }

  if (status === 'inactive') {
    return <span className="badge badge-danger">Inactive</span>;
  }

  if (status === 'onhold') {
    return <span className="badge badge-warning">Onhold</span>;
  }
  return null;
};

const AllProjects = () => {
  const [users, setUsers] = useState([]);
  const [searchuser, setSearchUser] = useState('');
  const [allProjects, setAllProjects] = useState([]);
  const [currentPage, setCurrentPage] = useState<any>(1);
  const [postPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [showLoader, setShowLoader] = useState(false);
  const [projectSearch, setProjectSearch] = useState('');

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const user = useSelector((state: any) => state.auth.currentUser);
  const path = localStorage.getItem('Path');
  const pageNo = Number(localStorage.getItem('PageNo')) || 1;

  useEffect(() => {
    if (path === 'projects' && pageNo !== 1) {
      setCurrentPage(pageNo);
      fetchProjects({pageNo});
      getAllUsers();
    } else {
      localStorage.setItem('Path', 'projects');
      localStorage.setItem('PageNo', currentPage);
      fetchProjects({});
      getAllUsers();
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('PageNo', currentPage);
  }, [currentPage]);

  const fetchProjects = async (query: any) => {
    // console.log(query, 'query*************');
    if (getUserPermission(user) === 'admin') {
      setShowLoader(true);
      const resp = await getAllProjects(query);
      handleStatus(resp.status, () => dispatch(logoutUser()), navigate);
      setAllProjects(resp?.data?.data);
      setTotalRecords(resp.data.totalRecords);
      setShowLoader(false);
    }
    if (
      getUserPermission(user) === 'developer' ||
      getUserPermission(user) === 'seo'
    ) {
      setShowLoader(true);
      const resp = await getAllProjectsAllowedForDevelopers(query);
      handleStatus(resp.status, () => dispatch(logoutUser()), navigate);
      // const result = await getAllProjectsForSearchingForDeveloper();
      setAllProjects(resp.data.data);
      // setProjectsForSearch(result.data.data);
      setTotalRecords(resp.data.totalRecords);
      setShowLoader(false);
    }
  };

  const onChange = (e: any) => {
    let value = e?.target?.value;
    if (value === 'Name') {
      value = '';
    }
    setSearchUser(value);
  };

  const getAllUsers = async () => {
    const res = await getAllUserNames();
    handleStatus(res.status, () => dispatch(logoutUser()), navigate);
    if (res.data.ok) {
      setUsers(
        res.data.data.map(({_id: id, name}: any) => ({value: id, label: name}))
      );
    }
  };

  const paginate = (pageno: number) => {
    const query = {
      pageNo: pageno
    } as any;

    if (searchuser) {
      query.userId = searchuser;
    }

    if (projectSearch && projectSearch.trim() !== '') {
      query.projectName = projectSearch.trim();
    }

    fetchProjects(query);
    setCurrentPage(pageno);
  };

  const filter = () => {
    setCurrentPage(1);
    fetchProjects({userId: searchuser, projectName: projectSearch});
  };

  const resetHandler = () => {
    setSearchUser('');
    setProjectSearch('');
    fetchProjects({});
  };

  const getClientName = (client: any) => {
    if (getUserPermission(user) !== 'admin') {
      return 'N/A';
    }
    return client ? client.clientName : 'N/A';
  };

  return (
    <>
      <ContentHeader title="All Projects" />
      <section className="content">
        <div className="container-fluid">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">All Projects Listing</h3>
            </div>
            <div className="card-body">
              <div className="col-12">
                <div className="card">
                  {showLoader && <Loader title="Loading projects..." />}
                  {!showLoader && allProjects.length === 0 && (
                    <p className="text-center text-muted">No records found</p>
                  )}
                  {!showLoader && allProjects.length > 0 && (
                    <>
                      <div className="card-header d-flex align-items-center justify-content-between flex-wrap">
                        <div className="input-group input-width w-100 d-flex align-items-center">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search project"
                            value={projectSearch}
                            onChange={(e) => setProjectSearch(e.target.value)}
                          />
                          {getUserPermission(user) === 'admin' && (
                            <select
                              onChange={onChange}
                              value={searchuser}
                              className="form-control mx-4"
                            >
                              <option defaultValue="" selected>
                                Name
                              </option>
                              {users.map(({_id: id, value, label}) => (
                                <option key={id} value={value}>
                                  {label}
                                </option>
                              ))}
                            </select>
                          )}
                          <div className="mx-2">
                            <Button variant="primary" onClick={filter}>
                              Search
                            </Button>
                          </div>
                          <div className="mx-2 caseResetButton">
                            <Button onClick={resetHandler} variant="primary">
                              Reset
                            </Button>
                          </div>
                        </div>
                      </div>
                      <div className="card-body table-responsive p-0">
                        <table className="table table-striped projects">
                          <thead>
                            <tr>
                              <th>S.No.</th>
                              <th className="text-center">Project Name</th>
                              <th className="text-center">Assigned To</th>
                              {getUserPermission(user) === 'admin' && (
                                <th className="text-center">Client</th>
                              )}
                              <th className="text-center">Status</th>
                              <th className="text-right">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {allProjects.map(
                              (
                                {
                                  _id: id,
                                  projectName,
                                  created_At: createdAt,
                                  assignedTo,
                                  status,
                                  client
                                }: any,
                                index
                              ) => {
                                const serialNumber =
                                  (currentPage - 1) * postPerPage + (index + 1);
                                const isAdmin =
                                  user.data.permissions[0] === 'admin';
                                const isDeveloperOrSEO = [
                                  'developer',
                                  'seo'
                                ].includes(user.data.permissions[0]);

                                if (isAdmin || isDeveloperOrSEO) {
                                  return (
                                    <tr key={id}>
                                      <td className="align-middle">
                                        {serialNumber}.
                                      </td>
                                      <td className="text-center align-middle">
                                        <a>{projectName}</a>
                                        <p className="mb-0 text-muted">
                                          Created{' '}
                                          {format(
                                            new Date(createdAt),
                                            'dd-MM-yyyy'
                                          )}
                                        </p>
                                      </td>
                                      <td className="text-center align-middle">
                                        <ul className="list-inline">
                                          {assignedTo.map(
                                            ({profile, _id: id}: any) => (
                                              <li
                                                key={id || Math.random()}
                                                className="list-inline-item"
                                              >
                                                <img
                                                  alt="Avatar"
                                                  className="table-avatar"
                                                  src={
                                                    profile?.trim()
                                                      ? profile
                                                      : 'https://www.kindpng.com/picc/m/252-2524695_dummy-profile-image-jpg-hd-png-download.png'
                                                  }
                                                />
                                              </li>
                                            )
                                          )}
                                        </ul>
                                      </td>
                                      {isAdmin && (
                                        <td className="text-center align-middle">
                                          {getClientName(client)}
                                        </td>
                                      )}
                                      <td className="text-center align-middle">
                                        <Status status={status} />
                                      </td>
                                      <td className="align-middle">
                                        <div className="d-flex justify-content-end project-actions">
                                          <Link
                                            to={`/view-project/${id}`}
                                            className="btn btn-primary btn-sm"
                                            data-tooltip-id="my-tooltip"
                                            data-tooltip-content="View Project"
                                          >
                                            <i className="fas fa-eye" />
                                          </Link>
                                          {isAdmin && (
                                            <Link
                                              to={`/update-project/${id}`}
                                              className="btn btn-primary btn-sm"
                                              data-tooltip-id="edit-tooltip"
                                              data-tooltip-content="Edit Project"
                                            >
                                              <i className="fas fa-pencil-alt" />
                                            </Link>
                                          )}
                                          <Link
                                            to={`/create-doc/${id}`}
                                            className="btn btn-primary btn-sm"
                                            data-tooltip-id="create-doc-tooltip"
                                            data-tooltip-content="Create Doc"
                                          >
                                            <i className="fas fa-file-alt" />
                                          </Link>
                                          <Tooltip id="my-tooltip" />
                                          {isAdmin && (
                                            <Tooltip id="edit-tooltip" />
                                          )}
                                          <Tooltip id="create-doc-tooltip" />
                                        </div>
                                      </td>
                                    </tr>
                                  );
                                }
                                return null;
                              }
                            )}
                          </tbody>
                        </table>
                      </div>
                      <div className="card-pagination">
                        <Pagination
                          postsPerPage={postPerPage}
                          totalPosts={totalRecords}
                          paginate={paginate}
                          currentPage={currentPage}
                        />
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="modal fade" id="modal-default">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Default Modal</h4>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <p>One fine body&hellip;</p>
              </div>
              <div className="modal-footer justify-content-between">
                <button
                  type="button"
                  className="btn btn-default"
                  data-dismiss="modal"
                >
                  Close
                </button>
                <button type="button" className="btn btn-primary">
                  Save changes
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AllProjects;
